import logo from './logo.svg';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './page/Login';
import { useState } from 'react';
import Home from './page/Home';
import ProtectedRouter from './page/ProducterRouter';
import VendorAdvance from './page/VendorAdvance';
import BillViewPage from './page/BillViewPage';
import BillProcessPage from './page/BillProcessPage';
import VehicleAdvance from './page/VehicleAdvance';
import Contractor from './page/Contractor';
import ContractorPayment from './page/ContractorPayment';
import Wagon from './page/Wagon';
function App() {

  const [logged, setLogged] = useState(() => {
    return localStorage.getItem("isLoggedIn") === "true";
  });

  const handleLogin = () => {
    setLogged(true);
    localStorage.setItem("isLoggedIn", "true");
  };

  const handleLogout = () => {
    setLogged(false);
    localStorage.removeItem("isLoggedIn");
  };
  return (
    <>
      <BrowserRouter>
      <Routes>
        <Route
        path='/login' element={<Login onLogin={handleLogin}/>}/>

        <Route
        path='/' element={<ProtectedRouter isLoggedIn={logged}>
          {/* <Home handleLogout={handleLogout} /> */}
           <BillViewPage handleLogout={handleLogout} />
        </ProtectedRouter>}/>
          <Route
        path='/vendorAdvance' element={<ProtectedRouter isLoggedIn={logged} >
         <VendorAdvance handleLogout={handleLogout} />
        </ProtectedRouter>}/>

         <Route
        path='/billView' element={<ProtectedRouter isLoggedIn={logged} >
           <BillViewPage handleLogout={handleLogout} />
        
        </ProtectedRouter>}/>
        <Route
        path='/billProcess' element={<ProtectedRouter isLoggedIn={logged} >
         <BillProcessPage handleLogout={handleLogout} />
        </ProtectedRouter>}/>
         <Route
        path='/vehicleAdvance' element={<ProtectedRouter isLoggedIn={logged} >
         <VehicleAdvance handleLogout={handleLogout} />
        </ProtectedRouter>}/>

          <Route
        path='/contractor' element={<ProtectedRouter isLoggedIn={logged} >
         <Contractor handleLogout={handleLogout} />
        </ProtectedRouter>}/>

          <Route
        path='/contractorPayment' element={<ProtectedRouter isLoggedIn={logged} >
         <ContractorPayment handleLogout={handleLogout} />
        </ProtectedRouter>}/>

          <Route
        path='/wagon' element={<ProtectedRouter isLoggedIn={logged} >
         <Wagon handleLogout={handleLogout} />
        </ProtectedRouter>}/>
        
      </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
